<template>
  <VAvatar :size="size" :image="image" :color="color">
    <template v-if="$slots['default']" #default>
      <slot name="default" />
    </template>
  </VAvatar>
</template>

<script setup lang="ts">
import { VAvatar } from 'vuetify/components/VAvatar';
import type { Size } from '~/infrastructure';

withDefaults(
  defineProps<{
    size?: Size | string | number;
    image?: string;
    color?: string;
  }>(),
  {
    size: 'default',
    image: undefined,
    color: undefined,
  },
);
</script>
